import { useMemo } from 'react';

import { useMenuCollectionsQuery } from './GraphQL';
import { formatMenuCollections } from './MenuCollectionsRail.utils';

// ────────────────────────────────────────────────────────────────────────────────

export const useMenuCollections = (
  menuId: string,
  excludedCollectionId?: string,
) => {
  const [menuCollectionsResponse] = useMenuCollectionsQuery({
    variables: { menuId },
    requestPolicy: 'cache-and-network',
    pause: !menuId,
  });
  const { fetching: isFetching, data } = menuCollectionsResponse;

  const formattedMenuCollections = useMemo(() => {
    const menuCollectionsList = data?.menuCollections ?? [];

    return formatMenuCollections(menuCollectionsList, excludedCollectionId);
  }, [data?.menuCollections, excludedCollectionId]);

  // ─────────────────────────────────────────────────────────────────

  return useMemo(
    () => ({ formattedMenuCollections, isFetching }),
    [formattedMenuCollections, isFetching],
  );
};
